// The org the user just picked, kept until the switch has landed. The switch takes the user to the
// root at once, and the user guard waits there for the pick to land before choosing the page (see
// `utils/route-guard/UserGuard.js`). The org selector sets it, and so does a notification action
// that has to change org first, which also names the page it is for (`destination`): the guard
// opens that instead of the org's default one. Switches started anywhere else (call queue,
// intercom) navigate on their own and never set it.
//
// It expires, so a switch that never lands cannot hold the root back much later.
const EXPIRES_AFTER_MS = 10000;

let pendingOrgId = null;
let pendingDestination = null;
let expiryTimer = null;

export const markOrgSelectorSwitch = (orgId, destination = null) => {
    clearTimeout(expiryTimer);
    pendingOrgId = orgId;
    pendingDestination = destination;
    expiryTimer = setTimeout(() => {
        pendingOrgId = null;
        pendingDestination = null;
    }, EXPIRES_AFTER_MS);
};

export const getPendingOrgSelectorSwitch = () => pendingOrgId;

export const getPendingOrgSelectorDestination = () => pendingDestination;

export const clearOrgSelectorSwitch = () => {
    clearTimeout(expiryTimer);
    pendingOrgId = null;
    pendingDestination = null;
};
